import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.scss';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Fix Leaflet default marker icons for bundlers (CRA/Webpack)
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
reportWebVitals();
